// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  // console.log(evt.detail.product);
});


// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  // console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  // console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  // console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant.option1);
  // Find all buttons within the product__color-chips class
    //const buttons = document.querySelectorAll('.product__color-chips button');

    // Loop through each button and remove the inline border-color style
    //buttons.forEach(function (button) {
    //    button.style.border = ''; // Removing the border-color style
    //});
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  // console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


document.addEventListener("DOMContentLoaded", function () {
    // Capture the event when an item is added to the cart
    document.addEventListener("cart:item-added", function (evt) {
        console.log("Item added to the cart");
        console.log(evt.detail.product); 
    });

  

    // Capture the event when the cart is opened
    document.addEventListener("cart:open", function (evt) {
        console.log("Cart opened");
    });

    // Capture the event when the cart is closed
    document.addEventListener("cart:close", function (evt) {
        console.log("Cart closed");
    });

    // Custom event if the default ones don't work
    // Example of dispatching a custom event manually
    var originalAddToCart = Shopify.addItem;
    Shopify.addItem = function (id, quantity, callback) {
        originalAddToCart(id, quantity, function (response) {
            console.log("Item added to cart manually:", response);
            document.dispatchEvent(new CustomEvent("custom:item-added", { detail: response }));
            if (callback) callback(response);
        });
    };

    // Listen for the custom event
    document.addEventListener("custom:item-added", function (evt) {
        console.log("Custom Event: Item added to the cart");
        console.log(evt.detail); // Log the custom event data
    });
      document.addEventListener("custom:item-remove", function (evt) {
        console.log("Custom Event: Item added to the cart");
        console.log(evt.detail); // Log the custom event data
    });
});

document.addEventListener("DOMContentLoaded", function () {
    // Capture the quick-add button click event
    document.querySelectorAll('[data-quick-shop-trigger="quick-add"]').forEach(function (button) {
        button.addEventListener("click", function (event) {
            console.log("Quick Add button clicked");
            console.log("Product ID:", button.getAttribute("data-product-id"));
        });
    });
});

